import type { SVGIconProps } from '../types';

export const WorkArrangementIcon: React.FC<SVGIconProps> = ({
  size = 16,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_1084_88"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1084_88)">
        <path
          d="M13.7301 10.5461C13.7301 8.78762 12.3046 7.36211 10.5461 7.36211C8.78762 7.36211 7.36211 8.78762 7.36211 10.5461C7.36211 12.3046 8.78762 13.7301 10.5461 13.7301C12.3046 13.7301 13.7301 12.3046 13.7301 10.5461ZM9.91118 9.27345C9.91118 8.9228 10.1955 8.63851 10.5461 8.63851C10.8968 8.63851 11.1811 8.9228 11.1811 9.27345V10.4314L11.8971 11.0048L11.9894 11.0953C12.1781 11.3221 12.1882 11.6576 11.9969 11.8971C11.8052 12.1367 11.4748 12.2014 11.2118 12.0668L11.1046 11.9969L10.1499 11.2333C9.99931 11.1128 9.91124 10.9301 9.91118 10.7373V9.27345ZM15 10.5461C15 13.0059 13.0059 15 10.5461 15C8.08633 15 6.09224 13.0059 6.09224 10.5461C6.09224 8.08633 8.08633 6.09224 10.5461 6.09224C13.0059 6.09224 15 8.08633 15 10.5461Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.27283 1C9.77862 1 10.2642 1.20097 10.622 1.55848C10.9796 1.91612 11.1803 2.40184 11.1804 2.90761V3.54627H13.0918C14.1453 3.54627 14.9992 4.40035 14.9994 5.45388V7.30834C14.6438 6.84027 14.2147 6.43143 13.7295 6.09814V5.45388C13.7293 5.10164 13.4441 4.81615 13.0918 4.81615H2.90761C2.55557 4.81644 2.27006 5.10182 2.26987 5.45388V8.28639C3.19528 8.85713 4.1973 9.28309 5.24037 9.55626C5.17207 9.90218 5.13595 10.2597 5.13595 10.6257C5.13595 10.6975 5.13881 10.769 5.14154 10.8401C4.14466 10.5988 3.17912 10.2337 2.26987 9.74926V11.8191C2.27004 12.1712 2.55556 12.4565 2.90761 12.4568H5.45015C5.61068 12.9105 5.82874 13.3367 6.09628 13.7267H2.90761C1.85427 13.7264 1.00017 12.8725 1 11.8191V5.45388C1.00019 4.40053 1.85428 3.54657 2.90761 3.54627H4.81894V2.90761C4.81912 2.40184 5.01979 1.91612 5.37743 1.55848C5.73509 1.20085 6.22077 1.00014 6.72655 1H9.27283ZM6.72655 2.26987C6.55755 2.27002 6.39482 2.33685 6.27529 2.45635C6.15578 2.57585 6.08899 2.73862 6.08882 2.90761V3.54627H9.91056V2.90761C9.91039 2.73862 9.8436 2.57585 9.72409 2.45635C9.60447 2.33696 9.44185 2.26987 9.27283 2.26987H6.72655Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
